import { Redirect, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app/components'
import { useModuleConfig } from '@webapp/app/config/useModuleConfig'
import { useAppRoutes } from '@webapp/hooks'
import { SpendAnalyticsPage } from '@webapp/pages'
import { Permissions } from '@webapp/platform/iam/entities'

export const DataAndInsightsRouter = () => {
  const { url } = useAppRoutes()

  const {
    routes: { enableDataAndInsightsRoute },
  } = useModuleConfig()

  const permissions = [
    Permissions.DATA_AND_INSIGHTS_ACCOUNTS_PAYABLE_DATA,
    Permissions.DATA_AND_INSIGHTS_EXPENSE_DATA,
    Permissions.DATA_AND_INSIGHTS_PURCHASING_DATA,
    Permissions.DATA_AND_INSIGHTS_SPEND_INSIGHTS,
  ]

  if (!enableDataAndInsightsRoute) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <ProtectedRoute
        exact
        path={url('SpendAnalyticsPage')}
        render={() => <SpendAnalyticsPage />}
        navigationPermissions={['data_and_insights__spend_insights']}
        permissions={permissions}
      />
    </Switch>
  )
}
